import { Box, Fab, SpeedDial, styled } from '../../base';
import { SIDE_MENU_WIDTH, TOP_HEADER_HEIGHT } from '../../common';

export const ContentContainer = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.background.mainBackground,
    flexGrow: '1',
}));

export const ContentBox = styled(Box)(({ theme }) => ({
    flex: '1',
    position: 'relative',
    overflow: 'auto',
    height: `calc(100vh - ${TOP_HEADER_HEIGHT}px)`,
    width: 'calc(100vw - 80px)',
    backgroundColor: theme.palette.background.mainBackground,
}));

export const PageLayoutWrapperBox = styled(Box)(() => ({
    display: 'flex',
    height: '100vh',
    flexDirection: 'row',
}));

export const BoxBelowTopHeader = styled(Box)(() => ({
    display: 'flex',
    flex: '1',
    overflow: 'hidden',
}));

export const SideMenuBox = styled(Box)(({ theme }) => ({
    flexShrink: '0',
    width: `${SIDE_MENU_WIDTH}px`, // Adjust to desired width
    height: '100vh',
    backgroundColor: theme.palette.primary.main,
    position: 'sticky',
    top: 0,
    left: 0, // Position based on theme direction
}));

export const ContentWrapper = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    overflow: 'hidden',
}));

export const StyledSpeedDial = styled(SpeedDial)(({ theme }) => ({
    position: 'absolute',
    bottom: '5%',
    insetInlineStart: '76px',
    zIndex: 20,
    '& .MuiFab-root': {
        background: `linear-gradient(180deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 86.24%)`,
        color: theme.palette.common.white,
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
        '&:hover': {
            background: `linear-gradient(180deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.main} 86.24%)`,
        },
    },
}));

export const MobileMenuButtonContainer = styled(Box)(({ theme }) => ({
    position: 'fixed',
    bottom: theme.spacing(2),
    insetInlineEnd: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1),
    zIndex: 1300,
}));
